import React from "react";
import Routing from "./Navigation";

const App = () => {
  return <Routing />;
};

export default App;
